<div class="flex gap-x-2">
  @for (holder of placeholders; track i; let i = $index) {
    <input
      #input
      (click)="onClick($event)"
      (paste)="onPaste($event, i)"
      (input)="onInput($event, i)"
      (keydown)="onKeydown($event, i)"
      type="tel"
      inputmode="numeric"
      pattern="[0-9]*"
      [disabled]="disabled"
      autocomplete="one-time-code"
      class="rounded border-black border px-3 py-2 h-[42px] bg-white text-mobileMd tablet:text-mobileMd desktop:text-desktopMd focus:outline-none w-full"
      [ngClass]="inputClass()"      
    />
  }
</div>
